const success = {
  100: "#DCFAE6",
  200: "#ABEFC6",
  300: "#75E0A7",
  400: "#47CD89",
  500: "#17B26A",
  600: "#079455",
  700: "#067647",
  800: "#085D3A",
  900: "#074D31",
  contrastDefaultColor: "#ffffff"
}

export default success
